module.exports = __webpack_public_path__ + "img/secondary_10x1.ce94ddcd.svg";